export default __webpack_public_path__ + "static/us-map-west-ba9a63ef1a205dd7f31f82b02c1797b6.svg";